import AWSServiceLink from './AWSServiceLink'

export default AWSServiceLink
